import { Crumbs } from "../components/Bits";
import { Head } from "../components/Head";
import { AUTHOR, EMAIL, SITE } from "../lib/util";

export function Om() {
  return (
    <>
      <Head title={"Om " + SITE} path="om/" desc={`Om ${SITE}: billige opskrifter, madplan og værktøjer til hverdagen.`} />
      <Crumbs trail={[[null, "Om os"]]} />
      <div className="wrap"><div className="ptop"><h1>Om {SITE}</h1></div><div className="prose" data-testid="om-content">
        <p>{SITE} samler billige og nemme opskrifter til hverdagens aftensmad, med en vejledende pris pr. person, så du kan se, hvad måltidet koster, før du handler.</p>
        <p>Vi tror på, at god mad ikke behøver være dyr eller svær. Alle opskrifter er skrevet til 4 portioner med en portionsberegner, så du kan skalere op og ned.</p>
        <h2>Sådan arbejder vi</h2><p>Opskrifterne er skrevet med almindelige danske råvarer og mål (dl, spsk, tsk). Priserne er skøn baseret på typiske priser i danske supermarkeder og kan variere. Tid og temperaturer er tommelfingerregler, så tjek altid, at maden er gennemstegt.</p>
        <h2>Kontakt</h2><p>Skriv til <a href={`mailto:${EMAIL}`}>{EMAIL}</a>, hvis du har rettelser, forslag til opskrifter eller spørgsmål.</p>
      </div></div>
    </>
  );
}

export function Privatliv() {
  return (
    <>
      <Head title="Privatliv og cookies" path="privatliv/" desc={`Sådan behandler ${SITE} dine oplysninger.`} />
      <Crumbs trail={[[null, "Privatliv"]]} />
      <div className="wrap"><div className="ptop"><h1>Privatliv og cookies</h1></div><div className="prose" data-testid="privatliv-content">
        <h2>Hvem er ansvarlig?</h2><p>{AUTHOR}. Kontakt: <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.</p>
        <h2>Hvad gemmer vi?</h2><p>Vi har ingen brugerprofiler. Din madplan, dine portionsvalg og afkrydsninger på indkøbslisten gemmes kun i din egen browser (lokal lagring), og de forlader aldrig din enhed. Du kan slette dem ved at rydde browserens data.</p>
        <h2>Cookies</h2><p>Siden bruger ingen sporingscookies. Hvis vi senere indfører annoncer eller statistik, opdaterer vi denne side og beder om dit samtykke.</p>
        <h2>Affiliate-links</h2><p>Nogle links kan være affiliate-links. Hvis du køber via dem, kan vi få en lille provision. Det påvirker ikke prisen for dig.</p>
        <h2>Dine rettigheder</h2><p>Du har ret til indsigt i og sletning af oplysninger om dig. Du kan klage til Datatilsynet (datatilsynet.dk).</p>
      </div></div>
    </>
  );
}
